/**
 * UPLOAD WIZARD REDUX REDUCERS
 *
 * Description here.
 *
 * @version 0.1
 */

import {
    DASHBOARD_RESET,
    DASHBOARD_NO_COMPANIES,
    DASHBOARD_WITH_COMPANIES,
    DASHBOARD_INFO_RECEIVED,
    HIDE_DASHBOARD_SPINNER,
    SHOW_DASHBOARD_SPINNERS,
    DASHBOARD_CHANGE_FILTER

} from './StartPage.actions';

function dashboardState(state = null, action) {

    switch (action.type) {

        case DASHBOARD_RESET:
            return Object.assign({}, state, {dashboardStage: null});
        
        case DASHBOARD_NO_COMPANIES:
            return Object.assign({}, state, {dashboardStage: DASHBOARD_NO_COMPANIES});

        case DASHBOARD_WITH_COMPANIES:
            return Object.assign({}, state, {dashboardStage: DASHBOARD_WITH_COMPANIES});

        case DASHBOARD_INFO_RECEIVED:
            let info = Object.assign({}, state.dashboardInfo, action.payload);
            return Object.assign({}, state, {dashboardInfo: info});

        case HIDE_DASHBOARD_SPINNER:

            let panelSpinner = Object.assign({}, state.dashboardInfo.spinners);
            panelSpinner[action.payload] = false;

            return Object.assign(
                {}, state, {
                    dashboardInfo: Object.assign(
                        {}, state.dashboardInfo, {
                            spinners: panelSpinner
                        }
                    )
                }
            );

        case SHOW_DASHBOARD_SPINNERS:
            return Object.assign(
                {}, state, {
                    dashboardInfo: Object.assign(
                        {}, state.dashboardInfo, {
                            spinners: {
                                activateSpinner: true,
                                addSpinner:      true,
                                manageSpinner:   true,
                                shareSpinner:    true
                            }
                        }
                    )
                }
            );
        case DASHBOARD_CHANGE_FILTER:
        {
            return Object.assign(
                {}, state, {
                    filters: Object.assign({}, state.filters, action.payload)
                }
            );
        }


        default:
            return state;

    }
}

export default dashboardState;


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/StartPage.reducers.js